import React from "react";
import SideBar from "../../components/Sidebar";

const FAQ = () => {
  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Frequently Asked Questions (FAQs)</h5>
              <p className="mb-4">
                Find answers to common questions related to our services.
              </p>

              {/* Recharge & Bill Section */}
              <Section
                title="Recharge & Bill"
                id="accordionRecharge"
                faqs={[
                  {
                    question: "Recharge not done but my money was deducted.",
                    answer:
                      "If your recharge failed but money was deducted, it will usually be refunded within 24–48 hours automatically. If not, contact support with transaction ID.",
                  },
                  {
                    question:
                      "I received a ‘Pending State’ message during recharge.",
                    answer:
                      "This means your transaction is under processing. Please wait 5–10 minutes. If the issue persists, raise a support ticket.",
                  },
                  {
                    question: "I was not able to recharge.",
                    answer:
                      "Please check your internet connection and ensure your payment method is valid. If the issue continues, try re-initiating the transaction.",
                  },
                  {
                    question: "I recharged a wrong number.",
                    answer:
                      "Unfortunately, recharges to wrong numbers are irreversible. Always double-check the number before confirming the transaction.",
                  },
                ]}
              />

              {/* Payments Section */}
              <Section
                title="Payments"
                id="accordionPayments"
                faqs={[
                  {
                    question: "How do I pay?",
                    answer:
                      "You can pay using UPI, credit/debit card, net banking, or wallet options provided during checkout.",
                  },
                  {
                    question: "How do I pay using a credit/debit card?",
                    answer:
                      "Select the card option during payment, enter card details and complete OTP verification to process the payment.",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// FAQ Accordion Section Component
const Section = ({ title, id, faqs }) => (
  <div className="mb-5">
    <div className="row">
      <div className="col-md-3">
        <h6 className="fw-bold">{title}</h6>
      </div>
      <div className="col-md-9">
        <div className="accordion accordion-flush" id={id}>
          {faqs.map((faq, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading-${id}-${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${id}-${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${id}-${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse-${id}-${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading-${id}-${index}`}
                data-bs-parent={`#${id}`}
              >
                <div className="accordion-body">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <hr />
  </div>
);

export default FAQ;
